import Base from './Base';


export default class ChamberOfCommerceModel extends Base  {
	public id: number;
	public code: number;
	public name: string;
	public coc_type: string;
	public is_checked: boolean;
	public checked_on: Date;
	
	constructor(data?: object) {
		super(null);
		this.id = 0;
		this.code = 0;
		this.coc_type = "";
		this.is_checked = false;
		this.checked_on = new Date();
		this.addData(data);
	}
			
	protected serialize() {
		const str = JSON.stringify(this);
		return str;
	}
	
	public createNewInstance() {
		return new ChamberOfCommerceModel();
	}


	
}